import type { ComponentPropsWithRef } from "react";

import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

import { cn } from "@/lib/utils";

export const SubmitButton = ({
  isSubmitting,
  className,
  disabled = false,
  children,
  ...props
}: {
  isSubmitting: boolean;
  children: React.ReactNode;
} & ComponentPropsWithRef<typeof Button>) => (
  <Button
    className={cn("relative rounded-full", className)}
    disabled={isSubmitting || disabled}
    type="submit"
    {...props}
  >
    <Spinner className={cn("hidden", isSubmitting && "block")} />
    {children}
  </Button>
);
